import * as React from 'react';
import { TpaSettingsProviderForWidget, TpaSettingsProviderForSettings, } from '.';
var tpaSettingsProviderWarnShown = false;
export var TpaSettingsProvider = function (_a) {
    var Wix = _a.Wix, editorSDK = _a.editorSDK, t = _a.t, experiments = _a.experiments, children = _a.children, publicData = _a.publicData, isMobile = _a.isMobile, isRTL = _a.isRTL, language = _a.language, revisionID = _a.revisionID, biConfig = _a.biConfig, componentRef = _a.componentRef, hostStyle = _a.hostStyle;
    // Checkf or editorSDK also
    var isWidgetMode = !Wix && publicData;
    if (isWidgetMode) {
        if (!tpaSettingsProviderWarnShown) {
            console.warn("Seems like you are using TPASettingsProvider to wrap a Widget.\nPlease, consider using TpaSettingsProviderForWidget to make tree-shaking work efficient.");
            tpaSettingsProviderWarnShown = true;
        }
        return (React.createElement(TpaSettingsProviderForWidget, { hostStyle: hostStyle, publicData: publicData, isMobile: isMobile, isRTL: isRTL, language: language, t: t, experiments: experiments }, children));
    }
    // Render a provider for Settings mode
    return (React.createElement(TpaSettingsProviderForSettings, { Wix: Wix, editorSDK: editorSDK, biConfig: biConfig, t: t, experiments: experiments, language: language, isRTL: isRTL, isMobile: isMobile, componentRef: componentRef, revisionID: revisionID }, children));
};
//# sourceMappingURL=TpaSettingsProvider.js.map